import axios from 'axios'
import router from '../router'
import store from '../store'
import { urlencode } from './common'

import { mapMutations } from 'vuex'

axios.defaults.withCredentials = true
export function requestApi (
  reqUrl,
  type = 'POST',
  data = {},
  auth = '',
  multipart = false,
  responseType = ''
) {
  if (!reqUrl) {
    return
  }
  let headers = {}

  if (auth === 'distributor') {
    if (
      typeof store.state.distributor === 'undefined' ||
      !store.state.distributor.token
    ) {
      router.push({ name: 'DistributorLogin' })
    }
    headers['X-DS-KEY'] = store.state.distributor.token
  }
  if (auth === 'member') {
    // if (typeof (store.state.member) === 'undefined' || !store.state.member.token) {
    //   router.push({ name: 'HomeLogin' })
    // }
    headers['X-DS-KEY'] = store.state.member.token
  }
  if (auth === 'seller') {
    if (
      typeof store.state.seller === 'undefined' ||
      !store.state.seller.token
    ) {
      router.push({ name: 'HomeSellerLogin' })
    }
    headers['X-DS-KEY'] = store.state.seller.token
  }
  if (multipart) {
    headers['Content-Type'] = 'multipart/form-data'
  }
  type = type.toUpperCase()
  reqUrl = env.API_HOST + reqUrl
  let axiosData
  if (type === 'POST') {
    if (responseType == '') {
      axiosData = {
        headers: headers,
        method: type,
        url: reqUrl,
        data: data
      }
    } else {
      axiosData = {
        headers: headers,
        method: type,
        url: reqUrl,
        data: data,
        responseType: responseType
      }
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(
      res => {
        // console.log(router.currentRoute.name)
        if (res.data.code === 10000) {
          return resolve(res.data)
        } else if (res.data.code === 11001) {
          console.log('code11001')
          // 将isOnline改为false
          // store.state.member.isOnline = false
          // localStorage.setItem('isOnline', false);

          store.state.member.info = null
          store.state.member.isOnline = false
          localStorage.setItem('isOnline', '')
          store.state.member.token = null
          localStorage.setItem('wxdl', '')
          // router.push({ name: 'HomeMemberLogin', query: { clear: 1 } }) // token过期，需要删除
          // 判断当前路由是否为分类或商品详情
          if (
            router.currentRoute.name !== 'HomeGoodsclass' &&
            router.currentRoute.name !== 'HomeGoodsdetail'
          ) {
            router.push({ name: 'HomeMemberLogin', query: { clear: 1 } }) // token过期，需要删除
          }
        } else if (res.data.code === 13001) {
          router.push({ name: 'HomeSellerLogin', query: { clear: 1 } }) // token过期，需要删除
        } else if (
          res.data.code === 10001 &&
          axiosData.url == '/api/Seccode/check'
        ) {
          console.log(axiosData, 'axiosData')
          return resolve(res.data)
        } else {
          reject(res.data)
        }
      },
      error => {
        reject(error)
      }
    )
  })
}

export function requestApiBody (
  reqUrl,
  type = 'POST',
  data = {},
  auth = '',
  multipart = false
) {
  if (!reqUrl) {
    return
  }
  let headers = {}

  if (auth === 'distributor') {
    if (
      typeof store.state.distributor === 'undefined' ||
      !store.state.distributor.token
    ) {
      router.push({ name: 'DistributorLogin' })
    }
    headers['X-DS-KEY'] = store.state.distributor.token
  }
  if (auth === 'member') {
    // if (typeof (store.state.member) === 'undefined' || !store.state.member.token) {
    //   router.push({ name: 'HomeLogin' })
    // }
    headers['X-DS-KEY'] = store.state.member.token
  }
  if (auth === 'seller') {
    if (
      typeof store.state.seller === 'undefined' ||
      !store.state.seller.token
    ) {
      router.push({ name: 'HomeSellerLogin' })
    }
    headers['X-DS-KEY'] = store.state.seller.token
  }
  if (multipart) {
    headers['Content-Type'] = 'multipart/form-data'
  }
  type = type.toUpperCase()
  reqUrl = env.API_HOST + reqUrl
  let axiosData
  if (type === 'POST') {
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl,
      data: data
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(
      res => {
        resolve(res.data)
      },
      error => {
        reject(error)
      }
    )
  })
}

export function requestRaw (reqUrl, type = 'POST', data = {}) {
  type = type.toUpperCase()
  let axiosData
  if (type === 'POST') {
    axiosData = {
      method: type,
      url: reqUrl,
      data: data
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      method: type,
      url: reqUrl
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(
      res => {
        resolve(res.data)
      },
      error => {
        reject(error)
      }
    )
  })
}
